import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  getSchoolLeadersEvaluations,
  downloadSchoolLeaderEvaluationPdf,
  puplishSchoolLeadersEvaluations,
} from "../../../../store/users/actions";
import ReactPaginate from "react-paginate";
// import PostRequestDetailsDialog from "../components/PostRequestDetailsDialog";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import NewUserDialog from "../components/NewUserDialog";
import PasswordRessetDialog from "../components/PasswordRessetDialog";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import UpdateUserDialog from "../components/UpdateUserDialog";
import { CSVLink } from "react-csv";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
// import AppealDialog from "../components/AppealDialog";

const SchoolLeadersEvaluations = (props) => {
  useEffect(() => {
    document.title = "TMIS | SCHOOL LEADERS' EVALUATIONS";
  }, []);

  const { hasPermissions } = useRequiredAuth();

  const {
    user,
    loading,
    getSchoolLeadersEvaluations,
    downloadSchoolLeaderEvaluationPdf,
    schoolLeadersEvaluations,
    puplishSchoolLeadersEvaluations,
  } = props;

  useEffect(() => {
    getSchoolLeadersEvaluations();
  }, []);

  const [showAppealDialog, setShowAppealDialog] = useState(false);
  const [selectedEvaluation, setSelectedEvaluation] = useState(null);

  const handleAppeal = (evaluation) => {
    setSelectedEvaluation(evaluation);
    setShowAppealDialog(true);
  };

  const [showPublishDialog, setShowPublishDialog] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([
    ...schoolLeadersEvaluations,
  ]);

  const onSearch = (term) => {
    setSearchTerm(term);
  };

  //PAGINATION
  const [paginatedItems, setPaginatedItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };

  useEffect(() => {
    paginate(filteredItems);
  }, [itemOffset, itemsPerPage, filteredItems]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % filteredItems.length || 0;

    setItemOffset(newOffset);
  };

  const getNo = (data, key, idToSearch) =>
    data.findIndex((item) => item[key] === idToSearch);

  useEffect(() => {
    const filtered = [...schoolLeadersEvaluations].filter(
      ({
        names,
        nidNumber,
        phoneNumber,
        email,
        schoolName,
        districtName,
        employeeId,
      }) =>
        (
          (names || "") +
          (schoolName || "") +
          (districtName || "") +
          (employeeId || "") +
          (email || "") +
          (nidNumber || "") +
          (phoneNumber || "")
        )
          .replace(/\s/g, "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase().replace(/\s/g, ""))
    );
    setFilteredItems(filtered);

    paginate(filtered);
  }, [searchTerm, schoolLeadersEvaluations]);

  return (
    <div className="px-4 pt-2">
      <div className="border rounded">
        <AppBar position="static" elevation={0} className="app-bar w-100">
          <Toolbar
            style={{
              minHeight: "0px",
              borderBottom: "3px solid #e9ecef",
            }}
            className=" my-0 py-1 bg-light"
          >
            <Typography
              variant="p"
              noWrap
              component="div"
              className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
            >
              SCHOOL LEADERS' EVALUATIONS
            </Typography>
            <Box sx={{ flexGrow: 1 }} />

            {hasPermissions(["SCHOOL_LEADERS_EVALUATIONS_PUBLISH"]) && (
              <Button
                className="mr-2"
                disabled={loading || !!schoolLeadersEvaluations[0]?.approved}
                onClick={() => {
                  setShowPublishDialog(true);
                }}
                variant="contained"
                size="small"
                disableElevation
                color="primary"
                style={{
                  borderRadius: "8px",
                  height: "32px",
                  alignItems: "center",
                  fontSize: ".75rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textTransform: "initial",
                }}
              >
                <span className="material-icons">send</span>
                Publish
              </Button>
            )}
            <Box sx={{ display: { xs: "flex", md: "flex" } }}>
              <SearchBox onSearch={onSearch} placeholder="Search…" />
            </Box>
          </Toolbar>
        </AppBar>

        <div
          style={{
            backgroundColor: "#f3f4f6",
            borderRadius: "0.5rem",
            boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
            MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
            height: "59vh",
            overflowY: "auto",
          }}
          className="px-3"
        >
          <table className="table table-striped table-hover fixTableHead">
            {!!paginatedItems?.length && (
              <thead>
                <tr style={{ backgroundColor: "#f0f2f5" }}>
                  <th scope="col">#</th>

                  <th scope="col" className="text-left">
                    Academic Year
                  </th>

                  <th scope="col" className="text-left">
                    EmployeeId
                  </th>

                  <th scope="col" className="text-left">
                    Names
                  </th>

                  <th scope="col" className="text-left">
                    Position
                  </th>

                  <th scope="col" className="text-left">
                    School Leadership /10
                  </th>

                  <th scope="col">District Evaluation /50</th>

                  <th scope="col" className="text-left">
                    English Proficiency /10
                  </th>

                  <th scope="col" className="text-left">
                    School Leadership/10
                  </th>

                  <th scope="col">District Evaluation/50</th>

                  <th scope="col" className="text-left">
                    English Proficiency/10
                  </th>

                  <th scope="col" className="text-left">
                    NESA Inspection/10
                  </th>

                  <th scope="col" className="text-left">
                    Students Performance for 3 Years/20
                  </th>

                  <th scope="col">Total Score/100</th>

                  <th scope="col">Category</th>

                  {/* <th scope="col">Comments</th> */}

                  {/* <th scope="col">Decision</th> */}
                  <th scope="col">Status</th>
                  {/* <th scope="col">Appeal</th> */}

                  <th scope="col">Actions</th>
                </tr>
              </thead>
            )}

            <tbody>
              {paginatedItems?.map((evaluation, index) => (
                <EvaluationCard
                  key={evaluation.id}
                  index={getNo(schoolLeadersEvaluations, "id", evaluation.id)}
                  evaluation={evaluation}
                  onDownloadPdf={downloadSchoolLeaderEvaluationPdf}
                  onAppeal={handleAppeal}
                />
              ))}
            </tbody>
          </table>

          {!paginatedItems?.length && (
            <div className="jumbotron jumbotron-fluid text-center">
              <div className="container py-5 ">
                <p className="lead">
                  {loading ? "Fetching data..." : "No record found"}{" "}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      {schoolLeadersEvaluations?.length > itemsPerPage && (
        <div className="mt-3">
          <ReactPaginate
            breakLabel="..."
            nextLabel={
              <>
                <span className="pr-1 d-none d-md-inline">Next</span>
                <i className="fas fa-angle-double-right"></i>
              </>
            }
            previousLabel={
              <>
                <i className="fas fa-angle-double-left"></i>
                <span className="pl-1  d-none d-md-inline">Previous</span>
              </>
            }
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            pageCount={pageCount}
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
            previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
            nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
            activeLinkClassName="active"
          />
        </div>
      )}

      {showPublishDialog && (
        <ConfirmationDialog
          confirmationDialog={showPublishDialog}
          message={
            <>
              <p className="mb-0 mt-3">
                Are you sure you want to publish school leaders evaluations?
              </p>
            </>
          }
          setConfirmationDialog={setShowPublishDialog}
          onYes={() => {
            puplishSchoolLeadersEvaluations(() => setShowPublishDialog(false));
          }}
        />
      )}

      {/* Appeal Dialog */}
      {/* <AppealDialog
        open={showAppealDialog}
        onClose={() => setShowAppealDialog(false)}
        evaluation={selectedEvaluation}
      /> */}
    </div>
  );
};

const mapStateToProps = ({ user, loading, schoolLeadersEvaluations }) => {
  return { user, loading, schoolLeadersEvaluations };
};

export default connect(mapStateToProps, {
  getSchoolLeadersEvaluations,
  downloadSchoolLeaderEvaluationPdf,
  puplishSchoolLeadersEvaluations,
})(SchoolLeadersEvaluations);

const EvaluationCard = (props) => {
  const { evaluation, index, onDownloadPdf, onAppeal } = props;

  const getAppealStatusBadge = (status) => {
    const statusConfig = {
      PENDING: { color: "#ffc107", bgColor: "#fff3cd", text: "Pending Review" },
      UNDER_REVIEW: {
        color: "#0dcaf0",
        bgColor: "#cff4fc",
        text: "Under Review",
      },
      APPROVED: { color: "#198754", bgColor: "#d1e7dd", text: "Approved" },
      REJECTED: { color: "#dc3545", bgColor: "#f8d7da", text: "Rejected" },
    };

    const config = statusConfig[status];

    if (!config) {
      return (
        <span className="text-muted" style={{ fontSize: "12px" }}>
          -
        </span>
      );
    }

    return (
      <span
        className="px-2 py-1 rounded"
        style={{
          backgroundColor: config.bgColor,
          color: config.color,
          fontSize: "12px",
          fontWeight: "500",
          display: "inline-block",
        }}
      >
        {config.text}
      </span>
    );
  };

  const canAppeal = () => {
    // Can appeal if no active appeal exists or if previous appeal was rejected
    return !evaluation.appealStatus || evaluation.appealStatus === "REJECTED";
  };

  return (
    <>
      <tr className={``}>
        <th scope="row" className="text-left">
          {index + 1}
        </th>

        <td className="text-left">{evaluation.academicYear}</td>
        <td className="text-left">{evaluation.employeeId}</td>
        <td className="text-left">{evaluation.names}</td>
        <td className="text-left">
          {evaluation.position} <br />@{evaluation.schoolName} /{" "}
          {evaluation.sectorName} / {evaluation.districtName}
        </td>
        <td className="text-left">{evaluation.schoolLeadershipTestScore}</td>
        <td className="text-left">{evaluation.districtEvaluationScore}</td>
        <td className="text-left">{evaluation.englishProficiencyTestScore}</td>
        <td className="text-left">{evaluation.nesaInspectionScore}</td>
        <td className="text-left">
          {evaluation.schoolLeadershipTestScore || "N/A"}
        </td>
        <td className="text-left">
          {evaluation.districtEvaluationScore || "N/A"}
        </td>
        <td className="text-left">
          {evaluation.englishProficiencyTestScore || "N/A"}
        </td>
        <td className="text-left">{evaluation.nesaInspectionScore || "N/A"}</td>
        <td className="text-left">
          {evaluation.threeYearsStudentsPerformanceRate || "N/A"}
        </td>
        <td className="text-left">{evaluation.totalScore}</td>
        <td className="text-left">{evaluation.category}</td>
        {/* <td className="text-left">{evaluation.comments}</td> */}
        {/* <td className="text-left">{evaluation.decision}</td> */}
        <td className="text-left">
          <span
            className={`badge badge-${
              evaluation.approved ? "success" : "secondary"
            }`}
          >
            {evaluation.approved ? "Published" : "Pending"}
          </span>
        </td>

        {/* Appeal Status Column */}
        {/* <td className="text-center">
          {getAppealStatusBadge(evaluation.appealStatus)}
        </td> */}

        {/* Actions Column */}
        <td className="text-left">
          <div className="d-flex gap-1">
            <Tooltip title="Download PDF Report">
              <IconButton
                size="small"
                onClick={() => onDownloadPdf(evaluation.id)}
                color="primary"
              >
                <span className="material-icons">download</span>
              </IconButton>
            </Tooltip>

            {/* {canAppeal() && (
              <Tooltip title="Submit Appeal">
                <IconButton
                  size="small"
                  onClick={() => onAppeal(evaluation)}
                  color="secondary"
                >
                  <span className="material-icons">gavel</span>
                </IconButton>
              </Tooltip>
            )} */}
          </div>
        </td>
      </tr>
    </>
  );
};
